import { Component } from "react";

export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-bone text-coal p-8 text-center">
          <span className="font-display text-3xl font-black">Alsat67</span>
          <p className="text-sm text-slate-600 max-w-sm">
            Beklenmeyen bir hata oluştu. Sayfayı yenilemeyi deneyin.
          </p>
          <button
            data-testid="error-reload-button"
            onClick={() => window.location.reload()}
            className="px-6 py-3 rounded-full bg-coral text-white font-semibold"
          >
            Sayfayı Yenile
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
